export default "__VITE_ASSET__CTJ5nmOz__"